<template>
	<div class="app-container">

		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
					<el-breadcrumb-item>标准服务</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<el-row class="left-img">
					<img src="@/assets/images/zltszhfw/standard/bzfw.png"/>
				</el-row>
				<el-row class="menu-box">
					<div>
						<div class="menu-level1" @click="changeMenu('威海市地方标准'),changeMenu2('威海市地方标准','0101','地方标准','')">
							威海市地方标准
						</div>
					</div>
					<div v-for="(item, index) in menuList" :key="item.name">
						<div class="menu-level1" :class="{active1:isActive==item.name}" @click="changeMenu(item.name)">
							{{item.name}}
							<span :class="isCollapse==item.name?menuIconDown:menuIcon"><i
									class="el-icon-arrow-right"></i></span>
						</div>
						<div v-show="isCollapse==item.name">
							<el-row :gutter="0">
								<el-col style="margin-bottom: 5px;text-align:left;" :span="12"
										v-for="(itemchild, index2) in item.labels" :key="itemchild.code">
									<span @click="changeMenu2(item.name,itemchild.code,itemchild.label,itemchild.url)"
										  class="menu-level2"
										  :class="{active2:isActive2==itemchild.code}">{{itemchild.label}}
									</span>
								</el-col>
							</el-row>
						</div>
					</div>
					<div>
						<div class="menu-level1"  @click="changeMenu('全国标准信息服务平台'),changeMenu2('全国标准信息服务平台','0401','服务平台','http://std.samr.gov.cn/')">
							全国标准信息服务平台 <span :class="menuIcon"><i class="el-icon-link"></i></span>
						</div>
					</div>
					<div>
						<div class="menu-level1" @click="changeMenu('一对一定制式标准技术服务'),changeMenu2('一对一定制式标准技术服务','0501','服务申请','/main/zltszhfw/bzfw/apply')">
							一对一定制式标准技术服务
						</div>
					</div>
					<div>
						<div class="menu-level1" @click="changeMenu('技贸破冰与筑篱'),changeMenu2('技贸破冰与筑篱','0601','技贸破冰与筑篱','')">
							技贸破冰与筑篱
						</div>
					</div>
					<div>
						<div class="menu-level1" @click="changeMenu('技术性贸易措施理论研究'),changeMenu2('技术性贸易措施理论研究','0602','技术性贸易措施理论研究','')">
							技术性贸易措施理论研究
						</div>
					</div>
					<div>
						<div class="menu-level1" @click="changeMenu('预警信息'),changeMenu2('预警信息','0603','预警信息','')">
							预警信息
						</div>
					</div>
					<div v-for="(item, index) in menuList2" :key="item.name">
						<div class="menu-level1" :class="{active1:isActive==item.name}" @click="changeMenu(item.name)">
							{{item.name}}
							<span :class="isCollapse==item.name?menuIconDown:menuIcon"><i
									class="el-icon-arrow-right"></i></span>
						</div>
						<div v-show="isCollapse==item.name">
							<el-row :gutter="0">
								<el-col style="margin-bottom: 5px;text-align:left;" :span="12"
										v-for="(itemchild, index2) in item.labels" :key="itemchild.code">
									<span @click="changeMenu2(item.name,itemchild.code,itemchild.label,itemchild.url)"
										  class="menu-level2"
										  :class="{active2:isActive2==itemchild.code}">{{itemchild.label}}
									</span>
								</el-col>
							</el-row>
						</div>
					</div>
<!--					<div>-->
<!--						<div class="menu-level1"  @click="changeMenu('标准认证咨询技术服务收费标准公示'),changeMenu2('标准认证咨询技术服务收费标准公示','0801','标准认证咨询技术服务收费标准公示','')">-->
<!--							标准认证咨询技术服务收费标准公示 <span :class="menuIcon"><i class="el-icon-link"></i></span>-->
<!--						</div>-->
<!--					</div>-->
				</el-row>
			</el-col>
			<el-col :span="18" class="right-box">
				<el-row class="right-box-row">
					<el-row class="right-box-row-tip">
						威海市产品质量标准计量检验研究院 联系电话：3859963
					</el-row>
					<el-row class="right-box-row-title">
						{{title}}
					</el-row>

					<el-row v-if="title == '威海市地方标准'">
						<el-form :model="queryParams" ref="queryParams" :inline="true" label-width="68px" size="small">
							<el-col :span="8">
								<el-form-item label="关键字：" prop="titleAndContent">
									<el-input v-model="queryParams.titleAndContent" placeholder="请输入关键字" clearable
											  size="small" style="width: 220px"/>
								</el-form-item>
							</el-col>
							<el-col :span="3">
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" size="mini" @click="getList" style="margin-right: 20px">检 索</el-button>
								</el-form-item>
							</el-col>
						</el-form>
					</el-row>
					<!-- 威海市地方标准 -->
					<el-row v-show="whdfbz_boolean">
						<el-table v-loading="loading" :data="list" :show-header="false" tooltip-effect="light" v-if="!isConsult">
							<el-table-column label="标题" align="left" prop="whsdfbzglTitle" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<span style="cursor: pointer" v-if="pageState==true"
										  @click="openPageDetail(scope.row)">{{scope.row.whsdfbzglTitle}}</span>
									<span v-else>{{scope.row.whsdfbzglTitle}}</span>
								</template>
							</el-table-column>
							<el-table-column label="日期" align="center" prop="whsdfbzglFbtime" :width="150">
								<template slot-scope="scope">
									<span>
										{{ parseTime(scope.row.whsdfbzglFbtime, '{y}-{m}-{d}') }}
									</span>
								</template>
							</el-table-column>
						</el-table>
						<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
									:limit.sync="queryParams.pageSize" @pagination="getList" />
					</el-row>
					<el-row v-show="hgbz_boolean">
						<el-table v-loading="loading" :data="list" :show-header="false" tooltip-effect="light" v-if="isConsult">
							<el-table-column label="标题" align="left" prop="hgbzTitle" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<span v-if="scope.row.hgbzType === '4'">[{{scope.row.hgbzHwmc}}] {{scope.row.hgbzTitle}}</span>
									<span v-else>[{{scope.row.hgbzBzh}}] {{scope.row.hgbzTitle}}</span>
								</template>
							</el-table-column>
							<el-table-column label="日期" align="center" prop="hgbzFbtime" :width="150">
								<template slot-scope="scope">
									<span>
<!--										{{ parseTime(scope.row.hgbzFbtime, '{y}-{m}-{d}') }}-->
									</span>
								</template>
							</el-table-column>
							<el-table-column label="咨询" align="center"
								class-name="small-padding fixed-width" width="130">
								<template slot-scope="scope">
									<el-button size="mini" type="text" icon="el-icon-chat-dot-round"
										@click="openPage('/main/zxzxForm')">
										咨询
									</el-button>
								</template>
							</el-table-column>
						</el-table>
						<pagination v-show="total>0" :total="total" :page.sync="hgbzQueryParams.pageNum"
							:limit.sync="hgbzQueryParams.pageSize" @pagination="getHgBzList" />
					</el-row>
					<!--tbt-->
					<el-row v-show="hgtbt_boolean">
						<div class="search-where">
							<div class="search-item">
								<div class="search-item-left">
								</div>
								<div class="search-item-right">
									<el-input placeholder="请输入通报号" v-model="tbtQueryParams.reportCode"
										class="input-with-select" prefix-icon="el-icon-search">
										<el-button slot="append" type="primary" @click="getHgTbtList">检 索</el-button>
									</el-input>
								</div>
							</div>
						</div>
						<el-table v-loading="tbtLoading" :data="tbtList"
							:header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
							<el-table-column label="通报号" align="center" prop="reportCode" :show-overflow-tooltip="true"
								width="150" class="tests" />
							<el-table-column label="发布日期" align="center" prop="releaseDate"
								:show-overflow-tooltip="true" width="150" >
								<template slot-scope="scope">
									{{parseTime(scope.row.releaseDate, '{y}-{m}-{d}')}}
								</template>
							</el-table-column>
							<el-table-column label="通报类型" align="center" prop="circularsType"
								:show-overflow-tooltip="true" width="150" />
							<el-table-column label="ICS分类" align="center" prop="ics" :show-overflow-tooltip="true"
								width="150" />
							<el-table-column label="通报目标" align="center" prop="notificationObjectives"
								:show-overflow-tooltip="true" width="150" />
							<el-table-column label="链接" align="center" prop="enUrl" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<span style="cursor: pointer;color:dodgerblue"
										@click="openPage(scope.row.enUrl)">EN</span>
								</template>
							</el-table-column>
						</el-table><br>
						<!--<el-pagination class="pagination" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page.sync="tbtQueryParams.pageNum"
							:page-size="tbtQueryParams.pageSize" :hide-on-single-page="true" :page-sizes="[10, 20, 30, 40]"
							layout="total, sizes, prev, pager, next, jumper" :total="tbtTotal" @pagination="getHgTbtList">
						</el-pagination>-->
						<pagination v-show="tbtTotal>0" :total="tbtTotal" :page.sync="tbtQueryParams.pageNum"
									:limit.sync="tbtQueryParams.pageSize" @pagination="getHgTbtList" />
					</el-row>
					<!--sps-->
					<el-row v-show="hgsps_boolean">
						<div class="search-where">
							<div class="search-item">
								<div class="search-item-left">
								</div>
								<div class="search-item-right">
									<el-input placeholder="请输入通报号" v-model="spsQueryParams.reportCode"
										class="input-with-select" prefix-icon="el-icon-search">
										<el-button slot="append" type="primary" @click="getHgSpsList">检 索</el-button>
									</el-input>
								</div>
							</div>
						</div>
						<el-table v-loading="spsLoading" :data="spsList"
							:header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
							<el-table-column label="通报号" align="center" prop="reportCode" :show-overflow-tooltip="true"
								width="150" class="tests" />
							<el-table-column label="发布日期" align="center" prop="releaseDate"
								:show-overflow-tooltip="true" width="150">
								<template slot-scope="scope">
							{{parseTime(scope.row.releaseDate, '{y}-{m}-{d}')}}
						</template>
							</el-table-column>
							<el-table-column label="通报类型" align="center" prop="circularsType"
								:show-overflow-tooltip="true" width="150" />
							<el-table-column label="产品" align="center" prop="produces" :show-overflow-tooltip="true"
								width="150" />
							<el-table-column label="关键词" align="center" prop="keyWord" :show-overflow-tooltip="true"
								width="150" />
							<el-table-column label="链接" align="center" prop="enUrl" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<span style="cursor: pointer;color:dodgerblue"
										@click="openPage(scope.row.enUrl)">EN</span>
								</template>
							</el-table-column>
						</el-table><br>
						<!--<el-pagination class="pagination" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page.sync="spsQueryParams.pageNum"
							:page-size="spsQueryParams.pageSize" :hide-on-single-page="true" :page-sizes="[10, 20, 30, 40]"
							layout="total, sizes, prev, pager, next, jumper" :total="spsTotal" @pagination="getHgSpsList">
						</el-pagination>-->
						<pagination v-show="spsTotal>0" :total="spsTotal" :page.sync="spsQueryParams.pageNum"
									:limit.sync="spsQueryParams.pageSize" @pagination="getHgSpsList" />
					</el-row>
					<!--韩国出口受阻-->
					<el-row v-show="hgcksz_boolean">
						<div class="search-where">
							<div class="search-item">
								<div class="search-item-left">

								</div>
								<div class="search-item-right">
									<el-input placeholder="请输入编号" v-model="hgckszQueryParams.reportCode"
										class="input-with-select" prefix-icon="el-icon-search">
										<el-button slot="append" type="primary" @click="getHgCkSzList">检 索</el-button>
									</el-input>
								</div>
							</div>
						</div>
						<el-table v-loading="hgckszLoading" :data="hgckszList"
							:header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
							<el-table-column label="编号" fixed="left" align="center" prop="reportCode"
								:show-overflow-tooltip="true" width="150" class="tests" />
							<el-table-column label="日期" align="center" prop="releaseDate" :show-overflow-tooltip="true"
								width="150" >
								<template slot-scope="scope">
									{{parseTime(scope.row.releaseDate, '{y}-{m}-{d}')}}
								</template>
							</el-table-column>
							<el-table-column label="产品名称" align="center" prop="produces" :show-overflow-tooltip="true"
								width="150" />
							<el-table-column label="英文/韩文名称" align="center" prop="enKoreaName"
								:show-overflow-tooltip="true" width="150" />
							<el-table-column label="产品分类" align="center" prop="producesType"
								:show-overflow-tooltip="true" width="150" />
							<el-table-column label="制造商/出口公司" align="center" prop="manCompany"
								:show-overflow-tooltip="true" />
							<el-table-column label="地区" align="center" prop="area" :show-overflow-tooltip="true" />
							<el-table-column label="原因分类" align="center" prop="reasonType"
								:show-overflow-tooltip="true" />
							<el-table-column label="原因" align="center" prop="reasons" :show-overflow-tooltip="true" />
							<el-table-column label="韩国标准" align="center" prop="hgCriterion"
								:show-overflow-tooltip="true" />
							<el-table-column label="处理机构" align="center" prop="proceOrg"
								:show-overflow-tooltip="true" />
						</el-table><br>
						<!--<el-pagination class="pagination" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page.sync="hgckszQueryParams.pageNum"
							:page-size="hgckszQueryParams.pageSize" :hide-on-single-page="true" :page-sizes="[10, 20, 30, 40]"
							layout="total, sizes, prev, pager, next, jumper" :total="hgckszTotal" @pagination="getHgCkSzList">
						</el-pagination>-->
						<pagination v-show="hgckszTotal>0" :total="hgckszTotal" :page.sync="hgckszQueryParams.pageNum"
									:limit.sync="hgckszQueryParams.pageSize" @pagination="getHgCkSzList" />
					</el-row>
					<!-- 海关共建：贸易摩擦预警专栏、技贸破冰与筑篱、技术性贸易措施理论研究、预警信息 -->
					<el-row v-show="hggj_boolean">
						<el-table v-loading="hggjLoading" :data="hggjList" :show-header="false" tooltip-effect="light" v-if="!isConsult">
							<el-table-column label="标题" align="left" prop="title" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<span style="cursor: pointer" v-if="pageState==true"
										  @click="openPageDetail(scope.row,'zltshggj')">{{scope.row.title}}</span>
									<span v-else>{{scope.row.title}}</span>
								</template>
							</el-table-column>
							<el-table-column label="日期" align="center" prop="fbtime" :width="150">
								<template slot-scope="scope">
									<span>
										{{ parseTime(scope.row.fbtime, '{y}-{m}-{d}') }}
									</span>
								</template>
							</el-table-column>
						</el-table>
						<pagination v-show="hggjTotal>0" :total="hggjTotal" :page.sync="hggjQueryParams.pageNum"
									:limit.sync="hggjQueryParams.pageSize" @pagination="getHggjList" />
					</el-row>
					<!-- 检索标准 -->
					<el-row v-show="jsbz_boolean">
						<div class="search-where">
							<el-col :span="24" style="margin-bottom: 20px;">
								<el-row style="margin-bottom: 10px;">
									<el-col :span="8">
										<el-input placeholder="请输入标准号" v-model="jsbzQueryParams.bzh"
											class="input-with-select" style="width: 250px;">
										</el-input>
									</el-col>
									<el-col :span="8">
										<el-input placeholder="请输入标准组织" v-model="jsbzQueryParams.bzzz"
											class="input-with-select" style="width: 250px;">
										</el-input>
									</el-col>
									<el-col :span="8">
										<el-input placeholder="请输入中文标准名称" v-model="jsbzQueryParams.zwtitle"
											class="input-with-select" style="width: 250px;">
										</el-input>
									</el-col>
								</el-row>
								<el-row style="margin-bottom: 10px;">

									<el-col :span="8">
										<el-input placeholder="请输入起草单位" v-model="jsbzQueryParams.qcdept"
											class="input-with-select" style="width: 250px;">
										</el-input>
									</el-col>
									<el-col :span="8">
										<el-input placeholder="请输入标准状态" v-model="jsbzQueryParams.bzstatus"
											class="input-with-select" style="width: 250px;">
										</el-input>
									</el-col>
									<el-col :span="8">
										<el-button type="primary" @click="getJsbzList">检 索</el-button>
									</el-col>
								</el-row>
							</el-col>
						</div>
						<el-table v-loading="jsbzLoading" :data="jsbzList"
							:header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
							<el-table-column label="标准号" align="center" prop="bzh" :show-overflow-tooltip="true"
								 class="tests" />
							<el-table-column label="标准组织" align="center" prop="bzzz"
								:show-overflow-tooltip="true"  >
							</el-table-column>
							<el-table-column label="中文标准名称" align="center" prop="zwtitle"
								:show-overflow-tooltip="true"  />
							<el-table-column label="起草单位" align="center" prop="qcdept" :show-overflow-tooltip="true"
								 />
							<el-table-column label="标准状态" align="center" prop="bzstatus"
								:show-overflow-tooltip="true"  />
						</el-table><br>
						<pagination v-show="jsbzTotal>0" :total="jsbzTotal" :page.sync="jsbzQueryParams.pageNum"
									:limit.sync="jsbzQueryParams.pageSize" @pagination="getJsbzList" />
					</el-row>
					<!-- 企业标准托管申请 -->
					<el-row v-show="qybztgsq_boolean">
						<el-form :model="qybztgsqForm" :rules="qybztgsqRules" ref="qybztgsqForm" label-width="100px">
							<el-form-item label="申请内容" prop="content">
							    <el-input type="textarea" v-model="qybztgsqForm.content"
								:autosize="{ minRows: 10, maxRows: 20}"></el-input>
							  </el-form-item>
							  <el-form-item>
							    <el-button type="primary" @click="submitQybztgsqForm()">立即申请</el-button>
							    <el-button @click="resetForm('qybztgsqForm')">重置</el-button>
							  </el-form-item>
						</el-form>
					</el-row>
				</el-row>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	import {
		listZltsWhsdfbzgl,
		getZltsWhsdfbzgl,
		downloadPdfStandard
	} from "@/api/zlts/bzfw/zltsWhsdfbzgl";
	import { listZltsHggj} from "@/api/zlts/bzfw/zltsHggj";
	import { listZltsHgbz, getZltsHgbz } from "@/api/zlts/bzfw/zltsHgbz";
	import { listReport } from "@/api/zlts/bzfw/hg_out_block_report";
	import { listHgTbtReport } from "@/api/zlts/bzfw/hgTbtReport";
	import { listSpsReport } from "@/api/zlts/bzfw/hg_sps_report";
	import {updatePvNum} from "@/api/itempv/pv";
	import { listJsbz,getJsbz } from "@/api/zlts/bzfw/jsbz";
	import { addQybztgsq } from "@/api/zlts/bzfw/qybztgsq";


	export default {
		name: "standard",
		data() {
			return {
				title: "威海市地方标准",
				// 遮罩层
				loading: false,
				hgckszLoading: false,
				tbtLoading: false,
				spsLoading: false,
				hggjLoading: false,
				jsbzLoading: false,
				//是否有咨询
				isConsult: false,
				//是否能跳转到详情页
				pageState: false,
				//威海地方标准
				whdfbz_boolean:true,
				//韩国标准
				hgbz_boolean: false,
				//韩国tbt通报
				hgtbt_boolean: false,
				//韩国sps通报
				hgsps_boolean: false,
				//韩国出口受阻
				hgcksz_boolean: false,
				//海关共建（技贸破冰）
				hggj_boolean: false,
				//检索标准
				jsbz_boolean: false,
				//企业标准托管申请对象
				qybztgsq_boolean: false,
				// 总条数
				total: 0,
				hgckszTotal: 0,
				tbtTotal: 0,
				spsTotal: 0,
				hggjTotal: 0,
				jsbzTotal: 0,
				list: [],
				dataTbtList: [],
				dataSpsList: [],
				hgckszList: [],
				tbtList: [],
				spsList: [],
				hggjList: [],
				jsbzList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					whsdfbzglTitle:'',
					whsdfbzglContent: '',
					titleAndContent:'',
				},
				hgbzQueryParams: {
					pageNum: 1,
					pageSize: 10,
					hgbzType:undefined
				},
				hgckszQueryParams: {
					pageNum: 1,
					pageSize: 10,
					reportCode: undefined,
				},
				tbtQueryParams: {
					pageNum: 1,
					pageSize: 10,
					reportCode: undefined,
				},
				spsQueryParams: {
					pageNum: 1,
					pageSize: 10,
					reportCode: undefined,
				},
				hggjQueryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				jsbzQueryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				isActive: "威海市地方标准",
				isActive2: "0101",
				isCollapse: "威海市地方标准",
				menuIcon: 'menu-icon',
				menuIconDown: 'menu-icon-down',
				menuList: [
				{
					name: '韩国标准信息与法规',
					labels: [{
						label: '韩国KS标准',
						code: "0201"
					}, {
						label: '韩国团体标准',
						code: "0202"
					},
					{
						label: '韩国技术性法规',
						code: "0203"
					},
					{
						label: '韩国认证制度',
						code: "0204"
					},
					{
						label: '贸易摩擦预警专栏',
						code: "0205"
					}]
				},
				{
					name: '韩国标准通报查询',
					labels: [{
						label: 'TBT通报',
						code: "0301"
					}, {
						label: 'SPS通报',
						code: "0302"
					}, {
						label: '出入口受阻通报',
						code: "0303"
					}]
				},
			],
			menuList2: [
				{
					name: '标准托管服务',
					labels: [{
						label: '检索标准',
						code: "0701"
					}, {
						label: '企业标准托管申请',
						code: "0702"
					}]
				},
			],
			qybztgsqForm:{

			},
			qybztgsqRules:{
				content: [
					{ required: true, message: '请填写申请内容', trigger: 'blur' }
				]
			}
			}
		},
		created() {
			this.getList();
		},
		methods: {
			changeMenu(name, code) {
				this.isCollapse = name;
				this.isActive = name;
				this.isActive2 = undefined;
			},
			changeMenu2(name, code, name2,url) {
				// console.log(name,code,name2)
				this.isActive = name;
				this.isActive2 = code;
				this.queryParams.titleAndContent = '';
				if (code==='0101'){
					this.title = name;
					this.queryParams.pageNum = 1;
					this.getList();
					updatePvNum("zlts_bzfw_whsdfbz").then(response => {
						//pv 点击威海市地方标准
					});
				}else if (code === '0201'){
					this.title = name2;
					this.hgbzQueryParams.hgbzType = '1';
					this.hgbzQueryParams.pageNum = 1;
					this.getHgBzList();
					updatePvNum("zlts_bzfw_hgksbz").then(response => {
						//pv 点击韩国KS标准
					});

				}else if (code === '0202'){
					this.title = name2;
					this.hgbzQueryParams.hgbzType = '2';
					this.hgbzQueryParams.pageNum = 1;
					this.getHgBzList();
					updatePvNum("zlts_bzfw_hgttbz").then(response => {
						//pv 点击韩国团体标准
					});
				}else if (code === '0203'){
					this.title = name2;
					this.hgbzQueryParams.hgbzType = '3';
					this.hgbzQueryParams.pageNum = 1;
					this.getHgBzList();
					updatePvNum("zlts_bzfw_hgjsxfg").then(response => {
						//pv 点击韩国技术性法规
					});
				}else if (code === '0204'){
					this.title = name2;
					this.hgbzQueryParams.hgbzType = '4';
					this.hgbzQueryParams.pageNum = 1;
					this.getHgBzList();
					updatePvNum("zlts_bzfw_hgrzzd").then(response => {
						//pv 点击韩国认证制度
					});
				}else if (code === '0205'){
					this.title = name2;
					this.hggjQueryParams.type = 'zlts_bzfw_mymcyj';
					this.hggjQueryParams.pageNum = 1;
					this.getHggjList();
					updatePvNum("zlts_bzfw_mymcyj").then(response => {
						//pv 贸易摩擦预警专栏
					});
				}else if (code === '0301'){
					this.title = name2;
					this.tbtQueryParams.pageNum = 1;
					this.tbtQueryParams.reportCode = "";
					this.getHgTbtList();
					updatePvNum("zlts_bzfw_hgtbttb").then(response => {
						//pv 点击韩国TBT通报
					});
				}else if (code === '0302'){
					this.title = name2;
					this.spsQueryParams.pageNum = 1;
					this.spsQueryParams.reportCode = "";
					this.getHgSpsList();
					updatePvNum("zlts_bzfw_hgspstb").then(response => {
						//pv 点击韩国SPS通报
					});
				}else if (code === '0303'){
					this.title = name2;
					this.hgckszQueryParams.pageNum = 1;
					this.hgckszQueryParams.reportCode = "";
					this.getHgCkSzList();
					updatePvNum("zlts_bzfw_hgcksztb").then(response => {
						//pv 点击韩国出口受阻通报
					});
				}else if (code === '0401'){
					updatePvNum("zlts_bzfw_qgbzxxfwpt").then(response => {
						//pv 点击全国标准信息服务平台
					});
					window.open(url);
				}else if (code === '0501'){
					updatePvNum("zlts_bzfw_1to1").then(response => {
						//pv 点击一对一定制式标准技术服务
					});
					//跳转到录入页面
					this.toPage(url);
				} else if (code === '0601'){
					this.title = name2;
					this.hggjQueryParams.type = 'zlts_bzfw_jmpbyzl';
					this.hggjQueryParams.pageNum = 1;
					this.getHggjList();
					updatePvNum("zlts_bzfw_jmpbyzl").then(response => {
						//pv 技贸破冰与筑篱
					});
				} else if (code === '0602'){
					this.title = name2;
					this.hggjQueryParams.type = 'zlts_bzfw_jsxmycsllyj';
					this.hggjQueryParams.pageNum = 1;
					this.getHggjList();
					updatePvNum("zlts_bzfw_jsxmycsllyj").then(response => {
						//pv 技术性贸易措施理论研究
					});
				} else if (code === '0603'){
					this.title = name2;
					this.hggjQueryParams.type = 'zlts_bzfw_yjxx';
					this.hggjQueryParams.pageNum = 1;
					this.getHggjList();
					updatePvNum("zlts_bzfw_yjxx").then(response => {
						//pv 预警信息
					});
				} else if (code === '0701'){
					this.title = name2;
					this.jsbzQueryParams.pageNum = 1;
					this.getJsbzList();
					updatePvNum("yw_bzfw_jsbz").then(response => {
						//pv 预警信息
					});
				} else if (code === '0702'){
					this.title = name2;
					// qybztgsq_boolean
					this.getQybztgsq();
				} else if (code === '0801'){
					console.log('下载pdf')
					downloadPdfStandard().then(res => {
						//下载代码
						var blob = new Blob([res], {
						  type: "application/octet-stream;chartset=UTF-8"
						});
						console.log('blob',blob)
						var url = window.URL.createObjectURL(blob);
						var a = document.createElement("a");
						a.href = url;
						a.download = "标准认证咨询技术服务收费标准.pdf";
						a.click();
					});
				}
			},
			toPage(url) {

					//不用登录的页面，就可以直接跳转了
					this.$router.push({
						path: url,
					});
					this.$store.commit('SET_MAININDEX', url);

			},
			refresh() {
				this.getList();
				this.getHgBzList();
				this.getHgTbtList();
				this.getHgSpsList();
				this.getHgCkSzList();
			},
			handleSizeChange(val) {
			},
			handleCurrentChange(val) {
			},
			getList() {
				this.isConsult = false;
				this.pageState = true;
				this.whdfbz_boolean = true;
				this.hgtbt_boolean = false;
				this.hgsps_boolean = false;
				this.hgcksz_boolean = false;
				this.hgbz_boolean = false;
				this.hggj_boolean = false;
				this.jsbz_boolean=false;
				this.qybztgsq_boolean=false;
				this.loading = true;
				listZltsWhsdfbzgl(this.queryParams).then(response => {
				  this.list = response.rows;
				  for (let i = 0; i < this.list.length; i++) {
				    this.list[i].whsdfbzglContent = this.replaceImgSrc(this.list[i].whsdfbzglContent)
				  }
				  this.total = response.total;
				  this.loading = false;
				});
			},
			getHggjList() {
				this.isConsult = false;
				this.pageState = true;
				this.hggjLoading = true;
				this.hgtbt_boolean = false;
				this.hgsps_boolean = false;
				this.hgcksz_boolean = false;
				this.hgbz_boolean = false;
				this.whdfbz_boolean = false;
				this.hggj_boolean = true;
				this.jsbz_boolean=false;
				this.qybztgsq_boolean=false;
				listZltsHggj(this.hggjQueryParams).then(response => {
				  this.hggjList = response.rows;
				  for (let i = 0; i < this.hggjList.length; i++) {
				    this.hggjList[i].content = this.replaceImgSrc(this.hggjList[i].content)
				  }
				  this.hggjTotal = response.total;
				  this.hggjLoading = false;
				  console.log(this.hggjLoading);
				});
			},
			getHgBzList() {
				this.isConsult = true;
				this.pageState = false;
				this.hgtbt_boolean = false;
				this.hgsps_boolean = false;
				this.hgcksz_boolean = false;
				this.hgbz_boolean = true;
				this.whdfbz_boolean = false;
				this.hggj_boolean = false;
				this.jsbz_boolean=false;
				this.qybztgsq_boolean=false;
				this.loading = true;
				listZltsHgbz(this.hgbzQueryParams).then(response => {
				  this.list = response.rows;
				  this.total = response.total;
				  this.loading = false;
				});
			},
			getHgTbtList() {
				this.whdfbz_boolean = false;
				this.hgbz_boolean = false;
				this.hgtbt_boolean = true;
				this.hgcksz_boolean = false;
				this.hgsps_boolean = false;
				this.hggj_boolean = false;
				this.jsbz_boolean=false;
				this.qybztgsq_boolean=false;
				this.tbtLoading = true;
				listHgTbtReport(this.tbtQueryParams).then(response => {
					this.tbtList = response.rows;
					this.tbtTotal = response.total;
					this.tbtLoading = false;
				});
			},
			getJsbzList() {
				this.whdfbz_boolean = false;
				this.hgbz_boolean = false;
				this.hgtbt_boolean = false;
				this.hgcksz_boolean = false;
				this.hgsps_boolean = false;
				this.hggj_boolean = false;
				this.qybztgsq_boolean=false;
				this.tbtLoading = false;
				this.jsbz_boolean = true;
				listJsbz(this.jsbzQueryParams).then(response => {
					this.jsbzList = response.rows;
					this.jsbzTotal = response.total;
					this.jsbzLoading = false;
				});
			},
			getQybztgsq() {
				this.whdfbz_boolean = false;
				this.hgbz_boolean = false;
				this.hgtbt_boolean = false;
				this.hgcksz_boolean = false;
				this.hgsps_boolean = false;
				this.tbtLoading = false;
				this.hggj_boolean = false;
				this.jsbz_boolean = false;
				this.qybztgsq_boolean = true;
				this.qybztgsqForm = {};
			},
			getHgSpsList() {
				this.whdfbz_boolean = false;
				this.hgbz_boolean = false;
				this.hgtbt_boolean = false;
				this.hgcksz_boolean = false;
				this.hgsps_boolean = true;
				this.hggj_boolean = false;
				this.jsbz_boolean = false;
				this.qybztgsq_boolean = false;
				this.spsLoading = true;
				listSpsReport(this.spsQueryParams).then(response => {
					this.spsList = response.rows;
					this.spsTotal = response.total;
					this.spsLoading = false;
				});
			},
			getHgCkSzList() {
				this.whdfbz_boolean = false;
				this.hgbz_boolean = false;
				this.hgtbt_boolean = false;
				this.hgsps_boolean = false;
				this.hgcksz_boolean = true;
				this.hggj_boolean = false;
				this.jsbz_boolean = false;
				this.qybztgsq_boolean = false;
				this.hgckszLoading = true;
				listReport(this.hgckszQueryParams).then(response => {
					this.hgckszList = response.rows;
					this.hgckszTotal = response.total;
					this.hgckszLoading = false;
				});
			},
			openPage(url) {
				this.utils.windowOpen(url);
			},
			openPageDetail(row,type){
				// console.log("row===>",row);
				if (type != undefined && type != null && type != '') {
					var d = {};
					d.recid = row.recid;
					d.type = this.hggjQueryParams.type;
					sessionStorage.setItem("zltshggj",JSON.stringify(d));
					this.utils.windowOpen(`/main/zltszhfw/bzfw/detail/undefined`);
				} else {
					this.utils.windowOpen(`/main/zltszhfw/bzfw/detail/${row.recid}`);
				}

			},
			handleOpen(key, keyPath) {
				//console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				//console.log(key, keyPath);
			},
			handleSelect(key, keyPath) {
				if (key == '1') {
					this.title = "威海市地方标准";
					this.queryParams.pageNum = 1;
					this.getList();
				} else if (key == '2-1-1' || key == '2-1-2' || key == '2-1-3' || key == '2-1-4') {
					if (key == '2-1-1') {
						this.hgbzQueryParams.hgbzType = '1';
						this.title = "韩国KS标准";
					} else if (key == '2-1-2') {
						this.hgbzQueryParams.hgbzType = '2';
						this.title = "韩国团体标准";
					} else if (key == '2-1-3') {
						this.hgbzQueryParams.hgbzType = '3';
						this.title = "韩国技术性法规";
					} else if (key == '2-1-4') {
						this.hgbzQueryParams.hgbzType = '4';
						this.title = "韩国认证制度";
					}
					this.hgbzQueryParams.pageNum = 1;
					this.getHgBzList();
				} else if (key == '2-2') {
					this.title = "TBT通报";
					this.queryParams.pageNum = 1;
					this.getHgTbtList();
				} else if (key == '2-3') {
					this.title = "SPS通报";
					this.queryParams.pageNum = 1;
					this.getHgSpsList();
				} else if (key == '2-4') {
					this.title = "出口受阻通报";
					this.hgckszQueryParams.pageNum = 1;
					this.getHgCkSzList();
				} else if (key == '3') {
					window.open('http://std.samr.gov.cn/');
				} else if (key == '4') {
					/** window.open('http://std.samr.gov.cn/');**/
					//跳转到录入页面
					this.toPage('/main/zltszhfw/bzfw/apply');
				}

			},
			submitQybztgsqForm () {
				if (this.utils.isLoginTimeout()) {
					let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
					if(ssessionLoginUser != null && ssessionLoginUser != undefined){
						this.$refs["qybztgsqForm"].validate(valid => {
							this.qybztgsqForm.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
							this.qybztgsqForm.applyName = ssessionLoginUser.user.name;
						    if (valid) {
								let that  = this;
								this.$confirm(`是否提交申请?`, '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									addQybztgsq(that.qybztgsqForm).then(response => {
									    if (response.code === 200) {
									        that.msgSuccess("成功");
									        that.qybztgsqForm = {}
									    } else {
									        that.msgError(response.msg);
									    }
									});
								})
						    }
						})
					}
				} else {
					this.$confirm('您未登录或登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
			}
		}
	}
</script>

<style scoped>
	.app-container {
		padding:10px ;
		background-color: #ffffff;
	}

	.navigation {
		padding: 20px 15px;
		line-height: 20px;
		height: 60px;
		background-color: #F5F5F5;
		margin-bottom: 15px;
	}

	.left-img img {
		width: 100%;
	}

	.menu-box {
		background-color: #FAFAFA;
		padding: 15px 10px;
	}

	.menu-level1 {
		padding: 10px;
		background-color: #69B1F3;
		padding-left: 20px;
		font-size: 13px;
		text-align: left;
		margin-bottom: 10px;
		margin-top: 10px;
		cursor: pointer;
		color: white;
	}

	.menu-level2 {
		padding: 5px 20px 5px 20px;
		font-size: 12px;
		font-weight: 500;
		cursor: pointer;
	}
	.menu-icon {
		float: right;

	}

	/deep/.el-menu {
		text-align: left;
		background-color: #FAFAFA;
		border: 0;
	}
	/*
	.menu-box /deep/.el-menu-item.is-active {
		background-color: #EAEAEA;
	}
	*/

	.right-box {
		padding-left: 10px;
	}

	.right-box-row {
		border: 1px solid #cccccc;
		padding: 10px 15px;
	}

	.right-box-row-tip {
		padding: 10px;
		background-color: #FBF8E5;
	}

	.right-box-row-title {
		padding: 15px 0;
		text-align: left;
		color: #409eff;
		font-size: 18px;
		font-weight: bold;
		border-bottom: 1px solid #cccccc;
		margin: 10px 0;
	}

	.xqsq {
		min-height: 5rem;
		background-color: #ffaa00;
		color: #FFFFFF;
		font-size: 1.25rem;
		line-height: 5rem;
		border-radius: 0.0625rem;
		cursor: pointer;
	}

	.search-where {
		margin: 10px 0px;
		padding: 15px;
		background-color: #ffffff;
	}

	.search-item {
		display: flex;
		/*border-bottom: 1px solid #000000;*/
	}

	.search-item-left {
		line-height: 40px;
		font-weight: bold;
	}

	.search-item-right {
		/* flex: 1; */
		padding: 0px 10px;
	}

	.el-input {
		width: 600px;
	}
</style>
